<template>
  <v-app>
    <v-data-table
      v-model="selected"
      :headers="headers"
      :items="data"
      :single-select="singleSelect"
      item-key="id"
      show-select
      style="padding:25px"
    >
      <template v-slot:top>
        <div>
          <div>
            <v-toolbar style="box-shadow:none !important">
              <v-toolbar-title
                ><b>{{ title }}</b></v-toolbar-title
              >
              <v-spacer></v-spacer>

              <v-spacer></v-spacer>
              <v-breadcrumbs>Master Data / Storage Location</v-breadcrumbs>
              <v-btn icon v-on:click="getData()">
                <v-icon>mdi-refresh</v-icon>
              </v-btn>
            </v-toolbar>

            <div style="padding:0px 25px">
              <v-layout row>
                <v-flex md8>
                  <v-btn
                    rounded
                    style="margin-top:15px"
                    color="primary"
                    large
                    v-on:click="modalForm()"
                  >
                    <v-icon dark style="margin-right:10px">mdi-plus</v-icon>
                    Add Data
                  </v-btn>

                  <v-btn
                    rounded
                    class="ml-2"
                    style="margin-top:15px"
                    color="#1e6d42"
                    large
                    dark
                    :loading="loadingDownload"
                    v-on:click="exportData()"
                  >
                    <v-icon dark style="margin-right:10px"
                      >mdi-microsoft-excel</v-icon
                    >
                    Export
                  </v-btn>
                </v-flex>
                <v-flex md4>
                  <v-col cols="12" sm="6" md="12">
                    <v-text-field
                      label=""
                      v-model="val"
                      v-on:keyup.enter="getData()"
                      placeholder="Enter Your Keywords"
                      solo
                      append-icon="search"
                    ></v-text-field>
                  </v-col>
                </v-flex>
              </v-layout>
            </div>
          </div>
        </div>

        <v-dialog v-model="modal_form" max-width="500px">
          <v-card>
            <v-card-title>
              Storage Location
            </v-card-title>
            <v-card-text>
              <v-form ref="form" v-model="valid" lazy-validation>
                <div style="padding:10px">
                  <label>
                    Storage Location ID
                  </label>
                  <v-text-field
                    v-model="storage_location_code"
                    :rules="rules"
                    :disabled="disabled"
                    placeholder="Enter Storage Location ID"
                    required
                    solo
                  ></v-text-field>

                  <label>
                    Storage Location Name
                  </label>
                  <v-text-field
                    v-model="storage_location_name"
                    :rules="rules"
                    placeholder="Enter Storage Location Name"
                    required
                    solo
                  ></v-text-field>

                  <label>
                    Plant
                  </label>
                  <v-select
                    item-text="description"
                    item-value="plant_code"
                    v-model="plant_code"
                    :items="list_plant"
                    :rules="rules"
                    label="Choose Plant"
                    solo
                  ></v-select>
                </div>

                <div align="right">
                  <v-btn color="primary" text @click="modal_form = false">
                    Close
                  </v-btn>

                  <v-btn
                    color="primary"
                    text
                    :loading="loading"
                    v-on:click="processForm"
                  >
                    Process
                  </v-btn>
                </div>
              </v-form>
            </v-card-text>
          </v-card>
        </v-dialog>
      </template>

      <template v-slot:item.status="{ item }">
        <v-chip color="success" v-if="item.status == 'Y'">Active</v-chip>
        <v-chip color="error" v-if="item.status == 'N'">Inactive</v-chip>
      </template>

      <template v-slot:item.action="{ item }">
        <v-icon medium class="mr-2" @click="edit(item)">
          mdi-file-edit
        </v-icon>

        <v-icon
          medium
          class="mr-2"
          color="error"
          @click="changeStatus(item, 'N')"
          v-if="item.status == 'Y'"
        >
          mdi-close-circle
        </v-icon>

        <v-icon
          medium
          class="mr-2"
          color="success"
          @click="changeStatus(item, 'Y')"
          v-if="item.status == 'N'"
        >
          mdi-check-circle
        </v-icon>
      </template>
    </v-data-table>
  </v-app>
</template>

<script>
export default {
  methods: {
    getData() {
      var self = this
      var val = self.val

      var url = self.base_url + "master/getdata/storage_location"
      self.axios
        .post(url, {
          param: val,
        })
        .then(function(response) {
          self.data = response.data
        })
    },
    exportData() {
      var self = this
      var val = self.val
      var url = self.base_url + "master/export/storage_location"

      var param = {
        param: val,
      }

      var responseType = {
        responseType: "arraybuffer",
      }

      self.loadingDownload = true

      self.axios.post(url, param, responseType).then(function(response) {
        const blob = new Blob([response.data], {
          type:
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        })

        const url = window.URL.createObjectURL(blob)
        const link = document.createElement("a")
        link.href = url
        link.setAttribute("download", "storage_location.xlsx")
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        self.loadingDownload = false
      })
    },
    modalForm() {
      var self = this
      self.modal_form = true
      self.reset()
      self.disabled = false
    },
    edit(item) {
      var self = this
      self.modal_form = true

      self.id = item.id
      self.storage_location_code = item.storage_location_code
      self.storage_location_name = item.storage_location_name
      self.plant_code = item.plant
      self.disabled = true
    },
    reset() {
      this.id = ""
      this.$refs.form.reset()
      this.type = "INSERT"
    },
    processForm() {
      var self = this
      if (self.$refs.form.validate()) {
        var url = (url = self.base_url + "master/process/add_storage_location")
        self.loading = true

        self.axios
          .post(url, {
            storage_location_code: self.storage_location_code,
            storage_location_name: self.storage_location_name,
            plant: self.plant_code,
            id: self.id,
          })
          .then(function(response) {
            if (response.data) {
              self.modal_form = false
              alert("Data succesfully saved")
            } else {
              alert(response.data.messages)
            }
            self.getData()
            self.loading = false
          })
      }
    },
    changeStatus(item, status) {
      var self = this
      var url = self.base_url + "master/process/change_status"

      var text_confirm = "Are you sure you want to Deactivated this data ?"

      if (status == "Y") {
        text_confirm = "Are you sure you want to Activated this data ?"
      }

      this.$dialog.confirm({
        text: text_confirm,
        overlay: true,
        actions: {
          false: "No",
          true: {
            color: "red",
            text: "Yes",
            handle: () => {
              self.axios
                .post(url, {
                  id: item.id,
                  status: status,
                  table: "mst_storage_location",
                  field: "id",
                })
                .then(function(response) {
                  alert(response.data.message)
                  self.getData()
                })
            },
          },
        },
      })
    },
    getPlant() {
      var self = this
      var url = self.base_url + "master/dropdown/attribute/plant/plant_code"
      self.axios.get(url).then(function(response) {
        self.list_plant = response.data
      })
    },
  },
  mounted() {
    this.getData()
    this.getPlant()
  },
  data() {
    return {
      name: "Storage Location",
      title: "Data Storage Location",
      dialog: false,
      widgets: false,
      singleSelect: false,
      selected: [],
      showSelect: false,
      loadingDownload: false,
      val: "",
      headers: [
        {
          text: "Storage Location Code",
          value: "storage_location_code",
          width: 120,
        },
        {
          text: "Storage Location Name",
          value: "storage_location_name",
          width: 250,
        },
        {
          text: "Plant Name",
          value: "plant_name",
          width: 250,
        },
        { text: "Status", value: "status", sortable: true, width: 120 },
        { text: "Action", value: "action", sortable: false, width: 120 },
      ],
      data: [],
      modal_detail: false,
      detail: [],
      modal_form: false,
      rules: [
        (v) => !!v || "Form is required",
        //v => (v && v.length <= 10) || 'This form must be less than 10 characters',
      ],
      list_plant: [],

      //form..............................
      storage_location_code: "",
      storage_location_name: "",
      plant_code: "",
      id: "",
      type: "",
      disabled: false,
    }
  },
}
</script>
